import React from "react";
import BodyContent from "./components/bodyContent";
import HeaderContent from "./components/headerContent";
import * as Styles from "./styles";

const Plantao = () => {
  return (
    <Styles.Section>
      <Styles.Container>
        <Styles.HeaderFrame>
          <HeaderContent />
        </Styles.HeaderFrame>
        <Styles.BodyFrame>
          <BodyContent />
        </Styles.BodyFrame>
      </Styles.Container>
    </Styles.Section>
  );
};

export default Plantao;
